
import { Component, Prop, Vue } from "vue-property-decorator";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiFilePdfBox, mdiFileExcelBox } from "@mdi/js";
import { subYears, format, startOfYear, parse, startOfMonth, endOfYear, endOfMonth, getYear } from "date-fns";
import store from "@/store";

@Component({
  components: {
    SvgIcon,
  },
})
export default class KeyActivity extends Vue {

  get startDate() {
    let startDate: Date;
    const year = this.selectedYear;

    if (this.selectedPeriod === "all_year") {
      startDate = startOfYear(new Date(year, 0, 1));
    } else if (this.selectedPeriod.startsWith("T")) {
      const quarter = parseInt(this.selectedPeriod[1], 10);
      startDate = new Date(year, (quarter - 1) * 3, 1);
    } else {
      const date = parse(`${this.selectedPeriod} ${year}`, "MMMM yyyy", new Date());
      startDate = startOfMonth(date);
    }
    return startDate;
  }

  get endDate() {
    let endDate: Date;
    const year = this.selectedYear;

    if (this.selectedPeriod === "all_year") {
      endDate = endOfYear(new Date(year, 0, 1));
    } else if (this.selectedPeriod.startsWith("T")) {
      const quarter = parseInt(this.selectedPeriod[1], 10);
      endDate = endOfMonth(new Date(year, quarter * 3 - 1, 1));
    } else {
      const date = parse(`${this.selectedPeriod} ${year}`, "MMMM yyyy", new Date());
      endDate = endOfMonth(date);
    }
    return endDate;
  }

  @Prop({ required: true })
  public keyId!: number;
  @Prop({ required: true })
  public keyCreateAt!: Date;
  @Prop({ required: true })
  public dialog!: boolean;
  @Prop({ required: true })
  public type!: string;

  public years = [];
  public periods = [
    "all_year",
    "T1",
    "T2",
    "T3",
    "T4",
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];
  public selectedYear = new Date().getFullYear();

  public selectedPeriod = "all_year";

  public craList = [];
  private mdiFilePdfBox = mdiFilePdfBox;
  private mdiFileExcelBox = mdiFileExcelBox;

  public async mounted() {
    const startDate: number = getYear(new Date(this.keyCreateAt));
    for (let year = startDate; year <= new Date().getFullYear(); year++) {
      this.years.push(year);
    }
    this.craList = await store.dispatch("files/getCraList", { keyId: this.keyId });
  }

  public closeModal() {
    this.$emit("closeModal");
  }

  public async onClickRapport(report) {
    const link = await store.dispatch("files/getCra", { keyId: this.keyId, craName: report.name });
    window.open(link, "_blank", "noopener,noreferrer");
  }

  private getLink(exportFileType: string) {

    const urlFn = (exportType: string) => {
      const url = new URL(
        `/api/keys/${this.keyId}/${exportType}/${exportFileType}/`,
        this.$store.state.baseURL,
      );

      url.searchParams.set("startDate", this.startDate.toISOString());
      url.searchParams.set("endDate", this.endDate.toISOString());
      url.searchParams.set(
        "timeZone",
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      );
      url.searchParams.set("token", store.getters["oauth/getAccessToken"]);

      return url.toString();
    };
    const exportType = exportFileType === "pdf" ? "activity-report" : "activity-report-logs";
    return urlFn(exportType);
  }

}
